module.exports = __webpack_public_path__ + "static/media/YB5F13_3.4407b4b1.jpg";